import { useContext } from 'react';

import { ScenarioListContext } from '../context/ScenarioListContext';

export const useScenarioListContext = () => {
  return useContext(ScenarioListContext);
};
